export const endpoints = {
  companyReportItem: 'companyReport',
  languageOptions: 'companyReport/language/options',
  userGroupOptions: 'companyReport/usergroup/options',
  textSetAllOptions: 'companyReport/textSet/all/options',
  text: (textId: number, textSetId: number) => `companyReport/textSet/${textSetId}/text/${textId}`,
  specialReportTemplate: (id: number | string) => `specialReport/${id}/template`,

  filterDomains: 'report/filterDomains',
  filterFields: 'companyReport/field/options',
  filterMetadata: 'companyReport/field/metadata',
  periodPredefOptions: 'companyReport/period/options',
  dbFunction: 'companyReport/dbFunction/options',
  codeOptionsFor: (domainId: number) => `companyReport/field/${domainId}/options`,
  categoryOptionsFor: (domainId: number) => `companyReport/field/${domainId}/categoryOptions`,
  metadataTypeOptions: 'companyReport/metadataType/options'
};

export const saveReportsEndpoints = {
  savedReportEvaluation: 'companyReport/report/evaluation',
  savedReportsOptions: 'user/current/options/savedFavourites'
};
